exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive\r\n{\r\n    background: white;\r\n    overflow: auto;\r\n    padding: 6px;\r\n    float: right; \r\n    width: 24.99999%;\r\n}\r\n\r\n.gallery{\r\n    border: 1px solid#ccc;\r\n}\r\n\r\n.gallery:hover{\r\n    border: 1px solid #777;\r\n}\r\n\r\n.gallery img{\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.desc{\r\n    padding: 15px;\r\n    text-align: center;\r\n}\r\n\r\n*{\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n}\r\n\r\n.margin_bottom30{\r\n    margin-bottom: 30px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/gallery/gallery.component.css
// module id = ../../../../../src/app/components/gallery/gallery.component.css
// module chunks = main